import { render, staticRenderFns } from "./limit-list.vue?vue&type=template&id=28bd4cc0&scoped=true"
import script from "./limit-list.vue?vue&type=script&lang=js"
export * from "./limit-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd4cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28bd4cc0')) {
      api.createRecord('28bd4cc0', component.options)
    } else {
      api.reload('28bd4cc0', component.options)
    }
    module.hot.accept("./limit-list.vue?vue&type=template&id=28bd4cc0&scoped=true", function () {
      api.rerender('28bd4cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/property/limit-list.vue"
export default component.exports